import styled from 'styled-components';
import { Box } from 'edenred-ui';

export const CalculatorContainer = styled(Box)``;
export const CalculatorRow = styled<{ $mergedColumns: boolean }>(Box)`
  display: grid;
  grid-template-columns: 180px auto 120px;
  min-height: 48px;
  align-content: center;
  padding: 0 16px;
  border-top: 2px solid ${props => props.theme.gray10};

  & > div {
    display: flex;
    align-items: center;

    &:nth-child(2) {
      ${props => (props.$mergedColumns ? `grid-column: 1 / 3` : '')};
    }
  }
`;

export const CalculatorHeader = styled(CalculatorRow)`
  background-color: ${props => props.theme.primaryBackgroundAltColor};
  height: 32px;
  font-weight: 600;
`;

export const CalculatorSummary = styled(CalculatorRow)`
  background-color: ${props => props.theme.primaryBackgroundAltColor};
  border: none;
  display: grid;
  padding: 16px;
  grid-template-columns: auto 120px;

  & > div {
    flex-direction: column;
    align-items: start;
  }
`;

export const CrossedOutAmount = styled<{ $crossedOut: boolean }>(Box)`
  text-decoration: ${props => (props.$crossedOut ? 'line-through' : 'none')};
`;
